module.exports = __webpack_public_path__ + "static/media/mayanna.9ad92466.png";